import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const getCourseIdAtom = atom((get) => {
  const booking = get(currentBookingAtom);
  return booking?.courseId;
});
